<template>

<section
                class="elementor-section elementor-top-section elementor-element elementor-element-9664585 elementor-section-full_width elementor-section-content-bottom elementor-section-stretched dark-bg elementor-section-height-default elementor-section-height-default"
                data-id="9664585" data-element_type="section"
                data-settings="{&quot;stretch_section&quot;:&quot;section-stretched&quot;}">
                <div class="elementor-container elementor-column-gap-default">
                  <div
                    class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-e43cc32"
                    data-id="e43cc32" data-element_type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-f015c0b elementor-widget elementor-widget-title"
                        data-id="f015c0b" data-element_type="widget" data-widget_type="title.default">
                        <div class="elementor-widget-container">

                          <div class="theme-title text-white ">
                            <h6>Why Choose us</h6>

                            <h2 class="text-anime-style"> We create opportunity to reach potential</h2>
                            <div class="title-divider "><span class="title-divider-separator"></span></div>

                          </div>



                        </div>
                      </div>
                      <section
                        class="elementor-section elementor-inner-section elementor-element elementor-element-5b8b4e8 elementor-section-boxed elementor-section-height-default elementor-section-height-default default"
                        data-id="5b8b4e8" data-element_type="section">
                        <div class="elementor-container elementor-column-gap-default">
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-4c3bce8"
                            data-id="4c3bce8" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-bbcd495 elementor-widget elementor-widget-feature"
                                data-id="bbcd495" data-element_type="widget" data-widget_type="feature.default">
                                <div class="elementor-widget-container">




                                  <div class="featured-item style-4 text-white ">
                                    <div class="featured-icon"><i class="flaticon flaticon-airplane"></i></div>
                                    <div class="featured-desc">
                                      <div class="featured-title">
                                        <h4>Economical Air Freight</h4>
                                      </div>
                                      <p>Packers and movers are given intense training materials properly.</p>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-c8507c7"
                            data-id="c8507c7" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-cb6cb77 elementor-widget elementor-widget-feature"
                                data-id="cb6cb77" data-element_type="widget" data-widget_type="feature.default">
                                <div class="elementor-widget-container">




                                  <div class="featured-item style-4 text-white ">
                                    <div class="featured-icon"><i class="flaticon flaticon-fast-delivery-5"></i></div>
                                    <div class="featured-desc">
                                      <div class="featured-title">
                                        <h4>Time Bound deliveries</h4>
                                      </div>
                                      <p>Packers and movers are given intense training materials properly.</p>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section
                        class="elementor-section elementor-inner-section elementor-element elementor-element-b06f1f8 elementor-section-boxed elementor-section-height-default elementor-section-height-default default"
                        data-id="b06f1f8" data-element_type="section">
                        <div class="elementor-container elementor-column-gap-default">
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-6f0eada"
                            data-id="6f0eada" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-a73f2af elementor-widget elementor-widget-feature"
                                data-id="a73f2af" data-element_type="widget" data-widget_type="feature.default">
                                <div class="elementor-widget-container">




                                  <div class="featured-item style-4 text-white ">
                                    <div class="featured-icon"><i class="flaticon flaticon-global-services-1"></i></div>
                                    <div class="featured-desc">
                                      <div class="featured-title">
                                        <h4>Safety & Reliability</h4>
                                      </div>
                                      <p>Packers and movers are given intense training materials properly.</p>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-bddadce"
                            data-id="bddadce" data-element_type="column">
                            <div class="elementor-widget-wrap elementor-element-populated">
                              <div
                                class="elementor-element elementor-element-d45cb99 elementor-widget elementor-widget-feature"
                                data-id="d45cb99" data-element_type="widget" data-widget_type="feature.default">
                                <div class="elementor-widget-container">




                                  <div class="featured-item style-4 text-white ">
                                    <div class="featured-icon"><i class="flaticon flaticon-support"></i></div>
                                    <div class="featured-desc">
                                      <div class="featured-title">
                                        <h4>24/7 Online Support</h4>
                                      </div>
                                      <p>Packers and movers are given intense training materials properly.</p>
                                    </div>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div
                    class="hero-section elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-43088ab bg-img-sec"
                    data-id="43088ab" data-element_type="column"
                    data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                    <div class="elementor-widget-wrap">
                    </div>
                  </div>
                </div>
              </section>
</template>

<script>
export default {
 
  data() {
    return {
      
    };
  },
  
};
</script>

<style scoped>

@import "@/assets/theme-style6c2d.css";

.hero-section {
  background-image:url(../assets/bg2-1.jpg);
  background-size: cover;
  background-position: center;
}


</style>
